import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faHome,
  faUser,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt,
  faInfo,
  faSearch,
  faCopy,
  faCheck,
  faTimes,
  faClock,
  faChevronRight,
  faChevronLeft,
  faChevronUp,
  faChevronDown,
  faArrowUp,
  faArrowDown,
  faArrowsAltH,
  faChild,
  faUsersSlash,
  faUsers,
  faAddressCard,
  faTrafficLight,
  faCog,
  faChartBar,
  faBookOpen,
  faChartLine,
  faInfoCircle,
  faCalendarCheck,
  faCheckDouble,
  faLaptopCode,
  faHardHat,
  faPassport,
  faTrashAlt,
  faCompressAlt,
  faArrowAltCircleRight,
  faListAlt,
  faIndustry,
  faBars,
  faCheckCircle,
  faLaptopHouse,
  faQuestion,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faTrafficLight,
  faHome,
  faUser,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt,
  faInfo,
  faSearch,
  faCopy,
  faCheck,
  faTimes,
  faClock,
  faChevronRight,
  faChevronLeft,
  faChevronUp,
  faChevronDown,
  faArrowUp,
  faArrowDown,
  faArrowsAltH,
  faChild,
  faUsersSlash,
  faUsers,
  faAddressCard,
  faBookOpen,
  faChartLine,
  faInfo,
  faInfoCircle,
  faCalendarCheck,
  faCheckDouble,
  faLaptopCode,
  faHardHat,
  faPassport,
  faTrashAlt,
  faCompressAlt,
  faArrowAltCircleRight,
  faCog,
  faChartBar,
  faListAlt,
  faIndustry,
  faBars,
  faCheckCircle,
  faLaptopHouse,
  faQuestion
);

export { FontAwesomeIcon };
